<div class="main-content table-page empleados-page">
  <div class="container-fluid">
    <section class="table-page__hero">
      <div class="table-page__copy">
        <h1>Gestión de Empleados</h1>
        <p>Administre usuarios, puestos y estatus del personal desde una sola vista.</p>
      </div>

      <button type="button" mat-raised-button class="btn table-page__primary-btn" (click)="onClicMostrarModalEmpleado(null)">
        <i class="material-icons">person_add</i>
        <span>Alta de Empleado</span>
      </button>
    </section>

    <section class="table-page__card">
      <div class="table-page__toolbar">
        <mat-form-field appearance="outline" class="table-page__search-field">
          <mat-label>Buscar por nombre</mat-label>
          <input matInput aria-label="Buscar por nombre" type="text" id="nombreEmpleado" name="nombreEmpleado" maxlength="80"
            [ngModel]="searchTerm"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="onBusquedaEmpleadoChange($event)" />
        </mat-form-field>
      </div>

      <div class="table-page__table-wrap">
        <table class="table-page__table" *ngIf="listEmpleados.length > 0; else empleadosEmptyState">
          <thead>
            <tr>
              <th>Empleado</th>
              <th>Usuario</th>
              <th>Correo</th>
              <th>Puesto</th>
              <th>Estatus</th>
              <th class="table-page__actions-head">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let empleadoBean of listEmpleados">
              <td>
                <div class="table-page__cell-stack">
                  <strong class="table-page__name">{{ empleadoBean.persona.nombreCompleto }}</strong>
                  <span class="table-page__subtext">ID usuario: {{ empleadoBean.idUsuario || '-' }}</span>
                </div>
              </td>
              <td>
                <span class="table-page__text">{{ empleadoBean.usuario.user_nom }}</span>
              </td>
              <td>
                <span class="table-page__text">{{ empleadoBean.persona.correoelectronico }}</span>
              </td>
              <td>
                <span class="table-page__text">{{ empleadoBean.puesto.puesto }}</span>
              </td>
              <td>
                <div class="table-page__status-wrap">
                  <span class="table-page__status-badge" [ngClass]="getStatusClass(empleadoBean)">
                    {{ getStatusLabel(empleadoBean) }}
                  </span>
                  <mat-slide-toggle class="table-page__toggle"
                    [checked]="empleadoBean.usuario.estatus === 'ACTIVO'"
                    (change)="onClicAcualizaStatus(empleadoBean.usuario, $event)">
                  </mat-slide-toggle>
                </div>
              </td>
              <td class="table-page__actions">
                <button type="button" class="table-page__action-btn" (click)="onClicMostrarModalEmpleado(empleadoBean)">
                  <i class="material-icons">edit</i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <ng-template #empleadosEmptyState>
          <div class="table-page__empty" *ngIf="!loading; else empleadosLoadingState">
            <i class="material-icons">group_off</i>
            <strong>No se encontraron empleados</strong>
            <span>Pruebe con otro criterio de búsqueda o registre un nuevo empleado desde el botón superior.</span>
          </div>
        </ng-template>

        <ng-template #empleadosLoadingState>
          <div class="table-page__empty table-page__empty--loading">
            <i class="material-icons">hourglass_top</i>
            <strong>Cargando empleados...</strong>
          </div>
        </ng-template>
      </div>

      <div class="table-page__footer" *ngIf="showPagination">
        <div class="table-page__meta">
          <span>Mostrando {{ rangeEnd }} de {{ totalRegistros }} empleados</span>
          <span>Página {{ currentPage }} de {{ totalPages || 1 }}</span>

          <label class="table-page__page-size">
            <span>Ver:</span>
            <select [ngModel]="pageSize" (ngModelChange)="onPageSizeChange($event)">
              <option *ngFor="let option of pageSizeOptions" [ngValue]="option">{{ option }}</option>
            </select>
          </label>
        </div>

        <div class="table-page__pager" *ngIf="totalPages > 0">
          <button type="button" class="table-page__pager-link" (click)="firstPage()" [disabled]="currentPage === 1">
            Inicio
          </button>
          <button type="button" class="table-page__pager-link" (click)="previousPage()" [disabled]="currentPage === 1">
            Anterior
          </button>

          <ng-container *ngFor="let item of getPaginationItems()">
            <button
              *ngIf="isPageNumber(item); else empleadosPagerEllipsis"
              type="button"
              class="table-page__pager-page"
              [class.is-current]="item === currentPage"
              (click)="onPageChange(item)">
              {{ item }}
            </button>

            <ng-template #empleadosPagerEllipsis>
              <span class="table-page__pager-ellipsis">...</span>
            </ng-template>
          </ng-container>

          <button type="button" class="table-page__pager-link" (click)="nextPage()" [disabled]="currentPage === totalPages">
            Siguiente
          </button>
          <button type="button" class="table-page__pager-link" (click)="lastPage()" [disabled]="currentPage === totalPages">
            Último
          </button>
        </div>
      </div>
    </section>
  </div>
</div>
